.itemInstallmentPlan {
  width: 100%;
  max-width: 1600px;
  margin: var(--pgm-sys-spacing-0) auto var(--pgm-sys-spacing-6);
  overflow: visible;
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: var(--pgm-sys-spacing-4);
  background: transparent;
  color: var(--pgm-sys-color-on-surface);
}

.itemInstallmentPlan:last-of-type {
  margin-bottom: var(--pgm-sys-spacing-16);
}

.installmentHeader {
  display: flex;
  box-sizing: border-box;
  height: calc(var(--pgm-sys-spacing-16) + var(--pgm-sys-spacing-2));
  padding-block: var(--pgm-sys-spacing-6);
  padding-left: var(--pgm-sys-spacing-2);
  padding-right: var(--pgm-sys-spacing-1);
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
}

.installmentHeaderExpanded {
  border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
}

.headerMainContent {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
}

.collapseButton {
  --md-icon-button-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-focus-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-hover-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-hover-state-layer-color: var(--pgm-sys-color-on-surface-variant);
  flex: 0 0 auto;
}

.informationButton {
  --pgm-icon-button-shape-full: var(--pgm-sys-spacing-3);
  --md-outlined-icon-button-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-focus-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-hover-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-hover-state-layer-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-outline-color: var(--pgm-sys-color-outline-variant);
  flex: 0 0 auto;
}

.buttonLoader {
  display: inline-flex;
}

.headerTextActions {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
}

.headerTitle {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--pgm-sys-spacing-1);
  color: var(--pgm-sys-color-on-surface);
}

.headerDivider {
  color: var(--pgm-sys-color-on-surface-variant);
}

.headerSelection {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
}

.headerSelectionWithoutCheckbox {
  padding-right: var(--pgm-sys-spacing-4);
}

.paymentValues {
  display: flex;
  width: 332px;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
}

.paymentValueLabels,
.valueBars {
  display: flex;
  width: 100%;
}

.paymentValueLabels {
  align-items: center;
  justify-content: space-between;
  gap: var(--pgm-sys-spacing-2);
}

.paymentValue {
  display: inline-flex;
  min-width: max-content;
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
  color: var(--pgm-sys-color-on-surface-variant);
  white-space: nowrap;
}

.valueIndicator {
  width: var(--pgm-sys-spacing-2);
  height: var(--pgm-sys-spacing-2);
  flex: 0 0 var(--pgm-sys-spacing-2);
  border-radius: 50%;
}

.valueBar {
  display: block;
  box-sizing: border-box;
  height: var(--pgm-sys-spacing-1);
  border-radius: var(--pgm-sys-spacing-2);
}

.valueBar + .valueBar {
  border-left: 4px solid transparent;
  background-clip: padding-box;
}

.paidIndicator,
.paidBar {
  background: var(--pgm-sys-color-success);
}

.outstandingIndicator,
.outstandingBar {
  background: var(--pgm-sys-color-outline-variant);
}

.unpaidIndicator,
.unpaidBar {
  background: var(--pgm-sys-color-error);
}

.selectedActions {
  display: flex;
  align-items: center;
  gap: var(--pgm-sys-spacing-3);
  color: var(--pgm-sys-color-on-surface);
  white-space: nowrap;
}

.selectedValue {
  color: var(--pgm-sys-color-on-surface-variant);
}

.checkboxControl {
  position: relative;
  display: inline-flex;
  flex: 0 0 var(--pgm-sys-spacing-10);
  align-items: center;
  justify-content: center;
  width: var(--pgm-sys-spacing-10);
  height: var(--pgm-sys-spacing-10);
  margin: var(--pgm-sys-spacing-0);
  cursor: pointer;
}

.checkboxControl input {
  position: relative;
  width: var(--pgm-sys-spacing-4);
  height: var(--pgm-sys-spacing-4);
  margin: var(--pgm-sys-spacing-0);
  appearance: none;
  border: 2px solid var(--pgm-sys-color-on-surface-variant);
  border-radius: 2px;
  background: transparent;
  cursor: pointer;
}

.checkboxControl input:checked,
.checkboxControl input[data-indeterminate="true"] {
  border-color: var(--pgm-sys-color-primary);
  background: var(--pgm-sys-color-primary);
}

.checkboxControl input:checked::after {
  position: absolute;
  top: 0;
  left: var(--pgm-sys-spacing-1);
  width: var(--pgm-sys-spacing-1);
  height: var(--pgm-sys-spacing-2);
  border: solid var(--pgm-sys-color-on-primary);
  border-width: 0 2px 2px 0;
  content: "";
  transform: rotate(45deg);
}

.indeterminateIcon {
  position: absolute;
  width: var(--pgm-sys-spacing-4);
  height: var(--pgm-sys-spacing-4);
  color: var(--pgm-sys-color-on-primary);
  font-size: var(--pgm-sys-spacing-4);
  line-height: var(--pgm-sys-spacing-4);
  pointer-events: none;
}

.checkboxControl input:focus-visible {
  outline: 2px solid var(--pgm-sys-color-secondary);
  outline-offset: 2px;
}

.checkboxControl input:disabled {
  cursor: default;
  opacity: 0.38;
}

.installments {
  padding-left: var(--pgm-sys-spacing-14);
}

.installments > :last-child {
  border-bottom: 0;
}

.modalInscription {
  width: 100%;
  border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
  background: transparent;
}

.modalInscriptionOption {
  display: flex;
  padding: var(--pgm-sys-spacing-3);
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  color: var(--pgm-sys-color-on-surface);
}

.error {
  padding: var(--pgm-sys-spacing-2);
}

.error > :global(.alert) {
  margin: var(--pgm-sys-spacing-0);
}

@media (max-width: 768px) {
  .installmentHeader {
    height: auto;
    min-height: calc(var(--pgm-sys-spacing-16) + var(--pgm-sys-spacing-2));
    flex-wrap: wrap;
  }

  .headerMainContent {
    width: 100%;
    padding-top: var(--pgm-sys-spacing-0);
  }

  .headerTextActions {
    min-width: calc(100% - var(--pgm-sys-spacing-8));
  }

  .headerSelection {
    width: 100%;
    padding-left: var(--pgm-sys-spacing-10);
    justify-content: flex-end;
  }

  .paymentValues {
    width: min(100%, 332px);
  }

  .installments {
    padding-left: var(--pgm-sys-spacing-4);
  }

  .selectedActions {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}
